import { render, staticRenderFns } from "./SetupAPIHarvester.vue?vue&type=template&id=22875a3f&"
import script from "./SetupAPIHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupAPIHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports